// extracted by mini-css-extract-plugin
var _1 = "ProfileAISummaryWidgetFooter-moduleProfileAISummaryWidgetFooter__dsb0a";
export { _1 as "ProfileAISummaryWidgetFooter" }
